import React from 'react';
import { ChevronRight, Zap, Calendar, Download, Paperclip, Smile, Clock, CheckCircle, X } from 'lucide-react';
import fetchData from '../../api/fetchApi';
import { useParams } from 'react-router-dom';

// Inline PDF icon svg
const PdfIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true">
    <rect y="0.634766" width="22" height="23.7303" fill="url(#pattern0_pdf_icon)" />
    <defs>
      <pattern id="pattern0_pdf_icon" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_pdf_icon" transform="scale(0.00561798 0.00520833)" />
      </pattern>
      <image id="image0_pdf_icon" width="192" height="192" preserveAspectRatio="none" xlinkHref="data:image/png;base64,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" />
    </defs>
  </svg>
);

const ChatMessage = ({ message, time, isSender, senderName, attachments, onImageClick }) => {
  return (
    <div className={`flex items-end gap-3 ${isSender ? 'justify-end' : 'justify-start'}`}>
      {!isSender && (
        <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0"></div>
      )}
      <div className="max-w-lg">
        {!isSender && <div className="text-sm text-gray-500 mb-1">{senderName}</div>}
        <div className={`px-4 py-3 rounded-2xl ${isSender ? 'bg-[var(--Primary-Primary)] text-white rounded-br-none' : 'bg-white text-gray-800 rounded-bl-none'}`}>
          <p>{message}</p>
          {attachments && attachments.length > 0 && (
            <div className="mt-3 flex flex-col gap-2">
              {attachments.map(att => {
                const isImage = att.type && att.type.startsWith('image');
                const isPdf = att.type === 'application/pdf' || (att.name || '').toLowerCase().endsWith('.pdf');
                if (isImage) {
                  return (
                    <button
                      type="button"
                      key={att.uuid}
                      onClick={() => onImageClick && onImageClick(att)}
                      className="block text-left w-40 overflow-hidden rounded-lg border border-gray-200 bg-white hover:ring-2 hover:ring-[var(--Primary-Primary)] focus:outline-none"
                      title={att.name}
                    >
                      <img
                        src={att.thumbnail_url || att.url}
                        alt={att.name}
                        className="w-full h-28 object-cover"
                        loading="lazy"
                      />
                      <div className="px-2 py-1 text-[10px] text-gray-600 truncate bg-white">
                        {att.name}
                      </div>
                    </button>
                  );
                }
                if (isPdf) {
                  return (
                    <button
                      key={att.uuid}
                      type="button"
                      onClick={() => onImageClick && onImageClick({ ...att, isPdf: true })}
                      className="inline-flex items-center gap-2 px-2 py-1 text-[11px] rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                      title={att.name}
                    >
                      <PdfIcon className="w-5 h-5" />
                      <span className="truncate max-w-[120px]">{att.name}</span>
                    </button>
                  );
                }
                return (
                  <a
                    key={att.uuid}
                    href={att.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-2 py-1 text-[11px] rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                    title={att.name}
                  >
                    📎
                    <span className="truncate max-w-[120px]">{att.name}</span>
                  </a>
                );
              })}
            </div>
          )}
        </div>
        <div className={`text-xs mt-1 ${isSender ? 'text-right' : 'text-left'} text-gray-400`}>{time}</div>
      </div>
    </div>
  );
};

export default function ConsultationReplyPage() {
  const dir = "rtl";
  const [messages, setMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [replyText, setReplyText] = React.useState("");
  const [replyLoading, setReplyLoading] = React.useState(false);
  const [replyError, setReplyError] = React.useState(null);
  const [showEmojis, setShowEmojis] = React.useState(false);
  const [attachments, setAttachments] = React.useState([]); // File objects
  const [uploading, setUploading] = React.useState(false);
  const [consultation, setConsultation] = React.useState(null);
  const [consultationError, setConsultationError] = React.useState(null);
  const [consultationLoading, setConsultationLoading] = React.useState(true);
  const [previewImage, setPreviewImage] = React.useState(null); // {url, name, isPdf}
  const [showAllAttachments, setShowAllAttachments] = React.useState(false);
  const [consultationAttachments, setConsultationAttachments] = React.useState([]);
  const [attachmentsLoading, setAttachmentsLoading] = React.useState(false);
  const [attachmentsError, setAttachmentsError] = React.useState(null);
  
    // Close preview on ESC
    React.useEffect(() => {
      function onKey(e){
        if(e.key === 'Escape') setPreviewImage(null);
      }
      if(previewImage){
        window.addEventListener('keydown', onKey);
      }
      return () => window.removeEventListener('keydown', onKey);
    }, [previewImage]);
  const { id } = useParams();


  async function handleReplySubmit(e) {
    e.preventDefault();
    if (!replyText.trim() && attachments.length === 0) return;
    setReplyLoading(true);
    setReplyError(null);
    try {
      const form = new FormData();
      form.append('body', replyText);
      // Append each file (backend should expect these under 'attachments[]' or similar)
      attachments.forEach((file, idx) => {
        form.append('file', file, file.name);
      });
      await fetchData(`consultation/${id}/message`, 'POST', form);
      setReplyText('');
      setAttachments([]);
      const res = await fetchData(`consultation/${id}/messages`);
      setMessages(Array.isArray(res) ? res : []);
    } catch (err) {
      setReplyError('فشل إرسال الرد');
    } finally {
      setReplyLoading(false);
    }
  }

  const EMOJIS = ["😀","😁","😂","🤣","😊","😍","😎","😢","😡","👍","👎","🙏","✔️","❓","❗"]; 

  function handleEmojiSelect(emoji) {
    setReplyText(prev => prev + emoji);
  }

  async function handleFilesSelected(e) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    // size validation
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
    const MAX_TOTAL = 25 * 1024 * 1024; // 25MB total
    const currentTotal = attachments.reduce((sum,f)=>sum+f.size,0);
    let added = 0;
    const accepted = [];
    for (const f of files) {
      if (f.size > MAX_FILE_SIZE) {
        setReplyError(`الملف ${f.name} يتجاوز 10MB`);
        continue;
      }
      if (currentTotal + added + f.size > MAX_TOTAL) {
        setReplyError('إجمالي حجم الملفات تجاوز 25MB');
        break;
      }
      accepted.push(f);
      added += f.size;
    }
    setAttachments(prev => [...prev, ...accepted]);
    e.target.value = '';
  }

  function removeAttachment(name) {
    setAttachments(prev => prev.filter(a => a.name !== name));
  }

  React.useEffect(() => {
    async function loadMessages() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchData(`consultation/${id}/messages`);
        setMessages(Array.isArray(res) ? res : []);
      } catch (err) {
        setError("فشل تحميل الرسائل");
      } finally {
        setLoading(false);
      }
    }
    loadMessages();
  }, [id]);

  React.useEffect(() => {
    async function loadConsultation() {
      setConsultationLoading(true);
      setConsultationError(null);
      try {
        const res = await fetchData(`consultation?uuid=${id}`);
        setConsultation(res || null);
      } catch (err) {
        setConsultationError('فشل تحميل بيانات الاستشارة');
      } finally {
        setConsultationLoading(false);
      }
    }
    if (id) loadConsultation();
  }, [id]);

  // Load all attachments immediately when page opens (instead of waiting for button click)
  React.useEffect(() => {
    async function loadAttachments() {
      if (!id) return;
      setAttachmentsLoading(true);
      setAttachmentsError(null);
      try {
        const res = await fetchData(`consultation/${id}/attachments`);
        setConsultationAttachments(Array.isArray(res) ? res : []);
      } catch (err) {
        setAttachmentsError('فشل تحميل المرفقات');
      } finally {
        setAttachmentsLoading(false);
      }
    }
    loadAttachments();
  }, [id]);

  function statusBadge(status){
    if(!status) return null;
    const map = {
      assigned: { label: 'مُسندة', class: 'bg-green-100 text-green-700' },
      open: { label: 'مفتوحة', class: 'bg-blue-100 text-blue-700' },
      closed: { label: 'مغلقة', class: 'bg-gray-200 text-gray-600' },
      answered: { label: 'تم الرد', class: 'bg-green-100 text-green-700' },
    };
    const info = map[status] || { label: status, class: 'bg-gray-100 text-gray-600' };
    return (
      <span className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-full ${info.class}`}>
        <CheckCircle size={12} /> {info.label}
      </span>
    );
  }

  return (
    <div className="flex flex-col h-screen bg-white" dir={dir}>
      {previewImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="relative max-w-3xl w-full max-h-full"
            onClick={e => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-2 left-2 bg-black/60 text-white rounded-full p-2 hover:bg-black/80"
              onClick={() => setPreviewImage(null)}
            >
              <X size={20} />
            </button>
            <a
              href={previewImage.url}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute top-2 right-2 bg-black/60 text-white text-xs px-3 py-1 rounded hover:bg-black/80"
              onClick={e=> e.stopPropagation()}
            >تحميل</a>
            {previewImage.isPdf ? (
              <iframe
                src={previewImage.url}
                title={previewImage.name}
                className="w-full h-[80vh] bg-white rounded-lg shadow-lg"
              />
            ) : (
              <img
                src={previewImage.url}
                alt={previewImage.name}
                className="w-full h-auto rounded-lg shadow-lg object-contain max-h-[80vh]"
              />
            )}
            <div className="mt-2 text-center text-sm text-white truncate" title={previewImage.name}>{previewImage.name}</div>
          </div>
        </div>
      )}
      {/* Header */}
      <header className="bg-white border-b border-gray-200 p-4">
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
                <button className="p-1 rounded-full hover:bg-gray-100">
                    <ChevronRight size={24} className="text-gray-600"  
                    onClick={() => window.history.back()}
                    />
                </button>
                <h1 className="text-lg font-semibold text-[#1D2035]">الرد على الاستشارة القانونية</h1>
            </div>
        </div>
        <div className="mt-4 p-3 rounded-xl bg-gray-50 border border-gray-200 min-h-[90px]">
          {consultationLoading && <div className="text-sm text-gray-500">جاري تحميل بيانات الاستشارة...</div>}
          {consultationError && <div className="text-sm text-red-600">{consultationError}</div>}
          {consultation && !consultationLoading && !consultationError && (
            <>
              <div className="flex items-center gap-2 text-sm font-semibold text-[#1D2035]">
                <Zap size={18} className="text-gray-400" />
                <p className="truncate" title={consultation.title}>{consultation.title}</p>
                <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-md flex items-center gap-1 ml-auto" title={consultation.created_at}>
                  <Clock size={12} /> {new Date(consultation.created_at).toLocaleTimeString('ar-LY',{hour:'2-digit',minute:'2-digit'})}
                </span>
                {statusBadge(consultation.status)}
              </div>
              <div className="mt-2 text-xs text-gray-600 line-clamp-2" title={consultation.body}>{consultation.body}</div>
              <div className="mt-3 flex flex-wrap items-center gap-6 text-xs text-gray-500">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-700">العميل:</span>
                  <span>{consultation.client?.name || '—'}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-700">المحامي:</span>
                  <span>{consultation.lawyer?.name || '—'}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Calendar size={14} />
                  <span>{new Date(consultation.created_at).toLocaleDateString('ar-LY')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span>📌</span>
                  <span>{consultation.topic?.name || '—'}</span>
                </div>
                <button
                  type="button"
                  onClick={() => setShowAllAttachments(true)}
                  className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-100 border border-transparent hover:border-gray-200 transition text-gray-700"
                >
                  <Paperclip size={14} />
                  <span>{consultation.attachments?.length || consultationAttachments.length || 0} ملف مرفق</span>
                </button>
              </div> 
              </>
          )}
        </div>
      </header>

      {/* Chat Area */}
      <main className="flex-1 overflow-y-auto bg-[#f7f7f7] p-6">
        <div className="flex flex-col gap-6">
          <div className="text-center my-4">
            <span className="px-3 py-1 text-xs text-gray-500 bg-white rounded-full border">
              اليوم
            </span>
          </div>
          {loading && <div className="text-center text-gray-500">جاري التحميل...</div>}
          {error && <div className="text-center text-red-600">{error}</div>}
      {!loading && !error && messages.map((msg, index) => {
            const isSender = msg.sender_name === "Me"; // Replace with actual current user UUID
            return (
              <ChatMessage
                key={msg.uuid || index}
                message={msg.message}
                time={msg.created_at}
                isSender={isSender}
        senderName={isSender ? "أنت" : (msg.sender_name || "مستخدم")}
        attachments={msg.attachments || []}
        onImageClick={(att)=> setPreviewImage({ url: att.url, name: att.name, isPdf: att.type === 'application/pdf' || (att.name || '').toLowerCase().endsWith('.pdf') })}
              />
            );
          })}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 p-4 relative">
        {showEmojis && (
          <div className="absolute bottom-24 right-4 w-64 bg-white border rounded-lg shadow-lg p-2 grid grid-cols-6 gap-2 z-20">
            {EMOJIS.map(em => (
              <button
                type="button"
                key={em}
                className="text-xl hover:scale-110 transition"
                onClick={() => handleEmojiSelect(em)}
              >{em}</button>
            ))}
          </div>
        )}
        <form className="flex items-center gap-3" onSubmit={handleReplySubmit}>
          <input
            type="text"
            placeholder="اكتب رسالتك..."
            className="flex-1 w-full px-4 py-3 rounded-lg border border-gray-200 bg-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
            value={replyText}
            onChange={e => setReplyText(e.target.value)}
            disabled={replyLoading}
          />
          <button
            type="button"
            className={`p-3 rounded-lg hover:bg-gray-100 ${showEmojis ? 'bg-gray-100' : ''}`}
            tabIndex={-1}
            disabled={replyLoading}
            onClick={() => setShowEmojis(s => !s)}
          >
            <Smile size={22} className="text-gray-500" />
          </button>
          <div className="relative">
            <input
              id="chat-file-input"
              type="file"
              multiple
              className="hidden"
              onChange={handleFilesSelected}
            />
            <button
              type="button"
              className="p-3 rounded-lg hover:bg-gray-100"
              tabIndex={-1}
              disabled={replyLoading || uploading}
              onClick={() => document.getElementById('chat-file-input').click()}
            >
              <Paperclip size={22} className="text-gray-500" />
            </button>
            {uploading && <span className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full animate-pulse" />}
          </div>
          <button
            type="submit"
            className="px-6 py-3 text-white bg-[var(--Primary-Primary)] rounded-lg shadow-sm"
            disabled={replyLoading || !replyText.trim()}
          >
            {replyLoading ? "جاري الإرسال..." : "ارسال الرد"}
          </button>
        </form>
        {!!attachments.length && (
          <div className="mt-3 flex flex-wrap gap-2">
            {attachments.map((file, i) => (
              <div key={file.name + i} className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded text-xs">
                <span className="truncate max-w-[140px]" title={`${file.name} (${(file.size/1024).toFixed(1)}KB)`}>{file.name}</span>
                <button type="button" onClick={() => removeAttachment(file.name)} className="hover:text-red-600">
                  <X size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
        {replyError && <div className="text-center text-red-600 mt-2">{replyError}</div>}
      </footer>
      {showAllAttachments && (
        <div className="fixed inset-0 z-40 bg-black/40 flex items-center justify-center p-4" onClick={()=> setShowAllAttachments(false)}>
          <div className="bg-white w-full max-w-2xl max-h-[80vh] rounded-lg shadow-xl flex flex-col" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <h2 className="text-sm font-semibold">كل المرفقات</h2>
              <button onClick={()=> setShowAllAttachments(false)} className="p-1 rounded hover:bg-gray-100"><X size={18} /></button>
            </div>
            <div className="p-4 overflow-y-auto space-y-3 text-sm">
              {attachmentsLoading && <div className="text-gray-500">جاري التحميل...</div>}
              {attachmentsError && <div className="text-red-600">{attachmentsError}</div>}
              {!attachmentsLoading && !attachmentsError && consultationAttachments.length === 0 && (
                <div className="text-gray-500">لا توجد مرفقات</div>
              )}
              {!attachmentsLoading && !attachmentsError && consultationAttachments.length > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {consultationAttachments.map(att => {
                    const isImage = att.type && att.type.startsWith('image');
                    const isPdf = att.type === 'application/pdf' || (att.name || '').toLowerCase().endsWith('.pdf');
                    return (
                      <div key={att.uuid} className="group border rounded-lg overflow-hidden bg-gray-50 flex flex-col">
                        <div className="relative cursor-pointer" onClick={() => {
                          if (isImage) setPreviewImage({ url: att.url, name: att.name, isPdf: false });
                          else if (isPdf) setPreviewImage({ url: att.url, name: att.name, isPdf: true });
                          else window.open(att.url, '_blank');
                        }}>
                          {isImage ? (
                            <img src={att.thumbnail_url || att.url} alt={att.name} className="h-32 w-full object-cover" loading="lazy" />
                          ) : isPdf ? (
                            <div className="h-32 w-full flex flex-col items-center justify-center gap-2 text-gray-600 text-xs">
                              <PdfIcon className="w-10 h-10" />
                              <span>PDF</span>
                            </div>
                          ) : (
                            <div className="h-32 w-full flex items-center justify-center text-gray-500 text-xs">ملف</div>
                          )}
                          <span className="absolute top-1 right-1 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 transition">عرض</span>
                        </div>
                        <div className="px-2 py-1 text-[11px] truncate" title={att.name}>{att.name}</div>
                        <div className="px-2 pb-2 flex gap-2">
                          <button
                            className="flex-1 text-[10px] py-1 bg-[var(--Primary-Primary)] text-white rounded hover:opacity-90"
                            onClick={()=> window.open(att.url, '_blank')}
                          >تحميل</button>
                          {(isImage || isPdf) && (
                            <button
                              className="flex-1 text-[10px] py-1 bg-gray-200 rounded hover:bg-gray-300"
                              onClick={()=> setPreviewImage({ url: att.url, name: att.name, isPdf })}
                            >عرض</button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="px-4 py-3 border-t text-xs text-gray-500 flex justify-between">
              <span>الإجمالي: {consultationAttachments.length}</span>
              <button onClick={()=> setShowAllAttachments(false)} className="text-[var(--Primary-Primary)] hover:underline">إغلاق</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
